import "./Common.scss";

const QuickLinkModal = ({ closeModal, modalTitle, content }) => {
  return (
    <div className="popup_bg_bbs " onClick={closeModal}>
      <div className="password_change " onClick={(e) => e.stopPropagation()}>
        <div className="pophead_bbs">
          <h1>{modalTitle}</h1>
        </div>
        <div className="password_change_inner">
          {content}
          <div className="btns_wrap">
            <button className="btn_confirm" onClick={closeModal}>
              <span className="material-icons">닫기</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default QuickLinkModal;
